export default "__VITE_ASSET__DThLOYrA__"